import logo from './logo.svg';
import './App.css';

import { RenderRoutes } from "./routes/routes";

import { BrowserRouter as BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
	    <div>
	      <RenderRoutes />
	    </div>
	  </BrowserRouter>
  );
}

export default App;
